import "./Footer.css";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import pawnwhite from "../../assets/pawnwhitefooter.svg";

function Footer() {
    const [isLanguageSelectorActive, setLanguageSelectorActive] =
        useState(false);
    const handleLanguageSelectorClick = () => {
        setLanguageSelectorActive(!isLanguageSelectorActive);
    };
    const navigate = useNavigate();
    const location = useLocation();

    const scrollTo = (sectionId) => {
        const section = document.querySelector(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    const handlePricingClick = () => {
        if (location.pathname === "/") {
            scrollTo("#pricing-section");
        } else {
            navigate("/");
        }
    };

    return (
        <>
            <img
                src={pawnwhite}
                alt="Oakmate logo pawn white"
                className="logowhite"
            />
            <div className="footer-section-wrapper">
                <address
                    className="side-wrapper"
                    aria-label="Contact Information"
                >
                    <a
                        href="mailto:contact@oakmate.app"
                        className="mail-contact"
                    >
                        contact@oakmate.app
                    </a>
                    <div className="lucas-dev">
                        Made by <span className="lucas">lucas</span>
                    </div>
                </address>
                <nav
                    className="quick-links-wrapper"
                    aria-label="Footer Navigation"
                >
                    <button
                        type="button"
                        onClick={handlePricingClick}
                        className="link-footer"
                    >
                        Pricing
                    </button>
                    <button
                        type="button"
                        className="link-footer"
                        onClick={() => {
                            navigate("/download");
                        }}
                    >
                        Downloads
                    </button>
                    <button
                        type="button"
                        className="link-footer"
                        onClick={() => {
                            navigate("/app");
                        }}
                    >
                        Web App
                    </button>
                    <button
                        type="button"
                        className="link-footer"
                        onClick={() => {
                            navigate("/blog");
                        }}
                    >
                        Blog
                    </button>
                </nav>
                <nav
                    className="quick-links-wrapper"
                    aria-label="Social Media Links"
                >
                    <a
                        href="https://www.instagram.com"
                        className="link-footer"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        Instagram
                    </a>
                    <a
                        href="https://www.youtube.com"
                        className="link-footer"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Youtube"
                    >
                        Youtube
                    </a>
                    <a
                        href="https://discord.gg/XGCgEBkbjn"
                        className="link-footer"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Discord"
                    >
                        Discord
                    </a>
                    <a
                        href="https://www.tiktok.com"
                        className="link-footer"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Tiktok"
                    >
                        Tiktok
                    </a>
                </nav>
                <nav className="quick-links-wrapper" aria-label="Policies">
                    <div className="policies-wrapper">
                        <a href="/policy/service" className="link-footer">
                            Terms of service
                        </a>
                        <a href="/policy/privacy" className="link-footer">
                            Privacy policy
                        </a>
                        <a href="/policy/refund" className="link-footer">
                            Refund policy
                        </a>
                    </div>
                </nav>
                <div className="side-wrapper">
                    <div className="language-selector-wrapper">
                        <div className="language-selector-wrapper-absolute">
                            <button
                                type="button"
                                className="language-active-wrapper"
                                onClick={handleLanguageSelectorClick}
                                aria-haspopup="listbox"
                                aria-expanded={isLanguageSelectorActive}
                                aria-label="Select language"
                            >
                                <div className="language-indiv-active">
                                    English
                                </div>
                                <svg
                                    className={
                                        isLanguageSelectorActive
                                            ? "language-active-svg active"
                                            : "language-active-svg"
                                    }
                                    viewBox="0 0 320 512"
                                    width="100"
                                    title="angle-down"
                                    aria-hidden="true"
                                >
                                    <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" />
                                </svg>
                            </button>
                            <ul
                                className={
                                    isLanguageSelectorActive
                                        ? "languagelistwrapper active"
                                        : "languagelistwrapper"
                                }
                                role="listbox"
                                tabIndex={-1}
                            >
                                <li
                                    className="language-indiv"
                                    role="option"
                                    aria-selected={true}
                                >
                                    French
                                </li>
                                <li
                                    className="language-indiv"
                                    role="option"
                                    aria-selected={false}
                                >
                                    Spanish
                                </li>
                                <li
                                    className="language-indiv"
                                    role="option"
                                    aria-selected={false}
                                >
                                    Indian
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Footer Structure */}
            <div className="footer-section-wrapper-mobile">
                <nav
                    className="quick-links-wrapper-mobile"
                    aria-label="Footer Navigation Mobile"
                >
                    <div className="quick-links-column-mobile">
                        <button
                            type="button"
                            onClick={handlePricingClick}
                            className="link-footer-mobile"
                        >
                            Pricing
                        </button>
                        <button
                            type="button"
                            className="link-footer-mobile"
                            onClick={() => {
                                navigate("/download");
                            }}
                        >
                            Downloads
                        </button>
                        <button
                            type="button"
                            className="link-footer-mobile"
                            onClick={() => {
                                navigate("/app");
                            }}
                        >
                            Web App
                        </button>
                        <button
                            type="button"
                            className="link-footer-mobile"
                            onClick={() => {
                                navigate("/blog");
                            }}
                        >
                            Blog
                        </button>
                    </div>
                    <div className="quick-links-column-mobile">
                        <a
                            href="https://www.instagram.com/oakmate.app"
                            className="link-footer-mobile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            Instagram
                        </a>
                        <a
                            href="https://youtube.com/@oakmateapp"
                            className="link-footer-mobile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Youtube"
                        >
                            Youtube
                        </a>
                        <a
                            href="https://discord.gg/XGCgEBkbjn"
                            className="link-footer-mobile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Discord"
                        >
                            Discord
                        </a>
                        <a
                            href="https://www.tiktok.com/@oakmate.app"
                            className="link-footer-mobile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Tiktok"
                        >
                            Tiktok
                        </a>
                    </div>
                    <div className="quick-links-column-mobile">
                        <a
                            href="/policy/service"
                            className="link-footer-mobile"
                        >
                            Terms of service
                        </a>
                        <a
                            href="/policy/privacy"
                            className="link-footer-mobile"
                        >
                            Privacy policy
                        </a>
                        <a href="/policy/refund" className="link-footer-mobile">
                            Refund policy
                        </a>
                    </div>
                </nav>
                <div className="side-wrapper-mobile">
                    <address className="mail-contact-mobile">
                        <a href="mailto:contact@oakmate.app">
                            contact@oakmate.app
                        </a>
                    </address>
                    <div className="language-selector-wrapper-mobile">
                        <div className="language-selector-wrapper-absolute-mobile">
                            <button
                                type="button"
                                className="language-active-wrapper-mobile"
                                onClick={handleLanguageSelectorClick}
                                aria-haspopup="listbox"
                                aria-expanded={isLanguageSelectorActive}
                                aria-label="Select language"
                            >
                                <div className="language-indiv-active">
                                    English
                                </div>
                                <svg
                                    className={
                                        isLanguageSelectorActive
                                            ? "language-active-svg-mobile active"
                                            : "language-active-svg-mobile"
                                    }
                                    viewBox="0 0 320 512"
                                    width="100"
                                    title="angle-down"
                                    aria-hidden="true"
                                >
                                    <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" />
                                </svg>
                            </button>
                            <ul
                                className={
                                    isLanguageSelectorActive
                                        ? "languagelistwrapper-mobile active"
                                        : "languagelistwrapper-mobile"
                                }
                                role="listbox"
                                tabIndex={-1}
                            >
                                <li
                                    className="language-indiv-mobile"
                                    role="option"
                                    aria-selected={true}
                                >
                                    French
                                </li>
                                <li
                                    className="language-indiv-mobile"
                                    role="option"
                                    aria-selected={false}
                                >
                                    Spanish
                                </li>
                                <li
                                    className="language-indiv-mobile"
                                    role="option"
                                    aria-selected={false}
                                >
                                    Indian
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="lucas-dev">
                        Made by <span className="lucas">lucas</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;
